import script from "./PracticeOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./PracticeOptions.vue?vue&type=script&setup=true&lang=js"

import "./PracticeOptions.vue?vue&type=style&index=0&id=63cf6662&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63cf6662"]])

export default __exports__